
export const awards = {
  introduction: {
    subTitle: '微众银行金融科技高校技术大赛',
    subTitleEn: 'FinTechathon',
    titleImg: require('../../../assets/img/awards/title-web.png'),
    mobileTitleImg: require('../../../assets/img/awards/title-wap.png'),
    certificate: require('../../../assets/img/awards/certificate.png'),
    mobileCertificate: require('../../../assets/img/awards/certificate-wap.png'),
    intro: [
      '2022 深圳国际金融科技大赛（ FinTechathon ）—— 西丽湖金融科技大学生挑战赛（下文称“大赛”）自 9 月 19 日启动以来，历时 53 天完成初赛报名及作品提交，共吸引了超过 1400 名学生组成的 500+ 支队伍参赛。',
      '作为深圳市首届金融科技节中的重要一环，大赛主办方将为所有获奖者颁发区块链数字证书（唯一标识的数字化获奖评证），为进入决赛的同学提供 100 余张实习面试直通卡，为前三甲获奖选手提供奖杯及 69 +万元奖金。',
      '本届大赛所颁发的区块链数字证书，为所有获奖者提供具有唯一标识的数字化获奖凭证。获奖选手可随时查看和下载，校方、招聘企业等也可以扫码快速验证证书真伪，达到可信验证、高效互通的效果。未来，区块链数字证书可进一步拓展到奖学金认证、技能培训认证等场景，为金融科技人才专业资格与资质提供便捷的查验与认证通道，助力构建金融科技人才培养可信体系。'
      // '2022 深圳国际金融科技大赛（ FinTechathon ）—— 西丽湖金融科技大学生挑战赛如期而至，今年大赛设置了69+万元赛事奖金，提供100+个名企实习名额，除了人工智能与区块链两个技术赛道外，还新增金融产品经理赛道。',
      // '自9月19日开赛以来，共有500+支队伍，超过1400人报名参赛。经过评审团队的重重筛选，目前三个赛道已分别角逐出10支队伍进入到决赛环节。组委会将为入围决赛的所有选手提供具有唯一标识的数字化获奖凭证。获奖选手可随时查看和下载，校方、招聘企业等也可以扫码快速验证证书真伪，达到可信验证、高效互通的效果。',
      // '该数字证书基于微众区块链技术，采用国产安全可控开源平台FISCO BCOS为底层链，上链获奖信息防篡改、可追溯、数据来源可信任。'
    ],
    introLast: [
      '该数字证书基于微众区块链技术，采用国产安全可控开源平台FISCO BCOS为底层链，上链获奖信息防篡改、可追溯、数据来源可信任。微众区块链、深圳大学微众金融科技实验室、深圳市金融区块链发展促进会（金链盟）为该数字证书提供技术支持。',
      '经过专家评审多轮专业评审，保证初赛作品评审的公平公正，经过激烈角逐，人工智能、区块链、产品经理三个赛道的前十强脱颖而出，成功晋级决赛！入围决赛队伍如下：'
    ]
  },

  finalist: {
    title: '入围决赛队伍',
    subTitle: 'FINALIST',
    content: [
      {
        alias: 'ai',
        title: '人工智能赛道',
        color: '#E1574D',
        list: [
          {
            product: '计及隐私保护的分区电压预测',
            team: '108战队',
            member: '颜剑峰、田方正',
            school: '东南大学'
          },
          {
            product: 'ESG评级辅助系统',
            team: '小试牛刀',
            member: '高云龙、卢隆基、王雨菲、邱宇洲',
            school: '深圳大学'
          },
          {
            product: '面向智能体音感知的联邦学习系统-基于FATE平台',
            team: 'Fed-healthcare (联邦医疗)',
            member: '邱万勇、全晨',
            school: '北京理工大学'
          },
          {
            product: '基于跨境银行的单边客户的双边化',
            team: 'ABCD队',
            member: '王柯宇、陈锐明、李南燕、聂文洁、王裕杭',
            school: '深圳大学'
          },
          {
            product: 'AI推荐与搜索驱动的联邦数据增强分析平台',
            team: 'FTABI',
            member: '邵长城、许健、赵亮、周锦灏、朱骧',
            school: '广东工业大学'
          },
          {
            product: '工业智能协同隐私计算服务平台',
            team: 'Intelli5',
            member: '陈洁蔚、李琪琛、吴达、李婷婷、杨国铭',
            school: '北京邮电大学'
          },
          {
            product: '安全行驶助理-基于FATE的改进纵向逻辑回归模型',
            team: '我们会晋级对不队',
            member: '孙迎港、王文瑞、潘文博、杨一正、杨锦波',
            school: '哈尔滨理工大学、哈尔滨工业大学'
          },
          {
            product: '“Fate-AutiFraud”基于关联图数据的反欺诈联邦学习平台',
            team: 'PraMet',
            member: '孙健坤、孙欣妍、张钰欣、施明腾、阳家勋',
            school: '哈尔滨工业大学、北京大学'
          },
          {
            product: 'DCCR—基于FATE的去中心化企业信用评级系统',
            team: 'Quantbird',
            member: '张皓涵、赵文硕、邓玉祺、华逢睿、方潇',
            school: '香港科技大学（广州）'
          },
          {
            product: 'AIDEA-科技开发园区精准招商服务介绍',
            team: 'AIDEA',
            member: '刘奥、匡永堃、刘洋、吴京轩、常永健',
            school: '北京信息科技大学、北京邮电大学、东南大学'
          }
        ]
      },
      {
        alias: 'blockchain',
        title: '区块链赛道',
        color: '#7652E1',
        list: [
          {
            product: '医元疗-区块链医检一体化系统',
            team: '果粒中正',
            member: '刘昱杰、彭文豪、章锦、肖宇、曾浩',
            school: '江西师范大学'
          },
          {
            product: 'B-Recycle电池回收管理平台',
            team: '南山美少女',
            member: '陈绮琳、房美贤、刘宏宇、贺祥瑞、吴雅妃',
            school: '深圳大学'
          },
          {
            product: 'TEEChain：面向供应链金融的机密区块链系统',
            team: 'TEEChain',
            member: '王伟力、谢绍康、冯泉弼、冯柏钧、李宇轩',
            school: '南方科技大学'
          },
          {
            product: '湾区药械链——破解大湾区三地医疗监管差异难题的优化方案',
            team: '安托山九院',
            member: '郑黎彬、王与、伍诚杰',
            school: '深圳大学、电子科技大学'
          },
          {
            product: 'PrePay预付卡——面向中小微企业的预付卡管理方案',
            team: 'Phisher',
            member: '袁瑶、王斯锐、陈贤玲、刘志涛、叶紫桐',
            school: '深圳大学'
          },
          {
            product: '区块链赋能的新能源汽车众充运维平台',
            team: '雷神之锤队',
            member: '赵云凤、王梓蔚、刘铸滔、陈哲远、戴子明',
            school: '天津大学'
          },
          {
            product: '“碳e信”——基于区块链+高频大数据构建企业可信碳账户，助力企业节能减排的MRV平台',
            team: 'main_chain()',
            member: '邓小娟、习洪霖、罗子仪、谢洪斌、胡龙辉',
            school: '华南理工大学、成都理工大学、中国矿业大学、西北工业大学'
          },
          {
            product: '面向区块链的细粒度数据权限管理系统',
            team: 'TIDAL',
            member: '赵明阳、谢雨萌、梁浩天、李骐元、罗瑆琪',
            school: '北京理工大学'
          },
          {
            product: '区 块 链 + 数 字 保 单',
            team: '健康云链科技队',
            member: '王梦成、张强、钱彦屹、甘楠',
            school: '华侨大学'
          },
          {
            product: '基于区块链技术的农作物经济应用',
            team: 'whiteChainTeam',
            member: '李宇阳、代山琅、王铮、赵杨、车圆圆',
            school: '成都信息工程大学'
          }
        ]
      },
      {
        alias: 'pm',
        title: '产品经理赛道',
        color: '#376EFD',
        list: [
          {
            product: '基于数字人民币和区块链碳排放权交易市场',
            team: '反方向的钟',
            member: '林怡静、任晓旭',
            school: '北京邮电大学、天津大学'
          },
          {
            product: '微碳汇—— B to C碳交易平台',
            team: '银河护卫队',
            member: '邵佳瑞、曹瑞琳',
            school: '华南理工大学'
          },
          {
            product: '“卖碳翁”个人碳账户产品设计',
            team: '两个大美女',
            member: '蔡晓烨、陈沚楦',
            school: '暨南大学'
          },
          {
            product: 'CSG信用增级',
            team: 'CGS小队',
            member: '覃琬淇、李凌逸',
            school: '深圳大学、广东工业大学'
          },
          {
            product: 'WeLiveWeLove生物云抚养平台',
            team: '李舒了',
            member: '舒子洋、李丹妮',
            school: '成都信息工程大学'
          },
          {
            product: '新能源绿色电动车绿色金融',
            team: 'GN1',
            member: '刘子杰、刘家靖',
            school: '福州大学'
          },
          {
            product: '"手可摘星辰"绿色碳交易平台',
            team: '守护者',
            member: '黄僖、丘文婷',
            school: '广州工商学院'
          },
          {
            product: '一点绿盆栽小程序',
            team: 'WeRich',
            member: '孙艺迪、李舟和',
            school: '深圳大学'
          },
          {
            product: '绿点——基于区块链的碳排放权质押贷款平台',
            team: '绿点',
            member: '吴倩妮',
            school: '中山大学'
          },
          {
            product: 'Block碳（绿色出行）',
            team: 'Block碳',
            member: '齐珍、罗晶',
            school: '马来亚大学'
          }
        ]
      }
    ]
  }
}
